import React from 'react';
import { Tag } from 'antd';

export const STATUS_LABELS = {
  pending_coordinator_approval: 'Pending Manager',
  pending_employee_action:      'Pending Employee',
  pending_fm_approval:          'Pending FM Approval',
  completed:                    'Completed',
  rejected:                     'Rejected',
};

export const STATUS_COLORS = {
  pending_coordinator_approval: 'orange',
  pending_employee_action:      'blue',
  pending_fm_approval:          'purple',
  completed:                    'green',
  rejected:                     'red',
};

export const statusTag = (s) => (
  <Tag color={STATUS_COLORS[s] || 'default'}>{STATUS_LABELS[s] || s}</Tag>
);
